import React from 'react';

const GradientIcon = ({
  icon: Icon,
  size = 24,
  className = "",
  gradientStops = [
    { offset: '0%', color: '#22d3ee' },
    { offset: '50%', color: '#6366f1' },
    { offset: '100%', color: '#1d4ed8' }
  ],
  gradientAngle = 45,
  style,
  ...rest
}) => {
  // Generate unique ID for the gradient
  const gradientId = React.useId();

  // Calculate gradient coordinates based on angle
  const getGradientCoordinates = (angleDegrees) => {
    const angleRadians = (angleDegrees * Math.PI) / 180;
    const x2 = 50 + 50 * Math.cos(angleRadians);
    const y2 = 50 + 50 * Math.sin(angleRadians);

    return {
      x1: '50%',
      y1: '50%',
      x2: `${x2}%`,
      y2: `${y2}%`
    };
  };

  const gradientCoords = getGradientCoordinates(gradientAngle);

  return (
    <div className="inline-flex">
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient
            id={gradientId}
            {...gradientCoords}
          >
            {gradientStops.map((stop, index) => (
              <stop
                key={index}
                offset={stop.offset}
                style={{ stopColor: stop.color }}
              />
            ))}
          </linearGradient>
        </defs>
      </svg>

      <Icon
        size={size}
        className={`stroke-2 ${className}`}
        style={{
          stroke: `url(#${gradientId})`,
          fill: 'none',
          ...style
        }}
        {...rest}
      />
    </div>
  );
};

export default GradientIcon;